import BASE64 from 'crypto-js/enc-base64';
import HMACSHA256 from 'crypto-js/hmac-sha256';
import slugify from 'slugify';
import { URL_REGEX } from 'util/constants';

export const makeSlug = (str: string): string => {
  const slug: string = slugify(str, {
    replacement: '-',
    lower: true,
    strict: true,
  });

  return slug;
};

export const convertToQspString = (params: any, encode = true): string => {
  const keyValueArray = [];
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = params[key];
      if (value) {
        const encodedValue = fixedEncodeUriComponent(value);
        keyValueArray.push(`${key}=${encode ? encodedValue : value}`);
      }
    }
  }
  return keyValueArray.join('&');
};

export const createHash = (qsp: string, secret: string): string => {
  const hash = HMACSHA256(qsp, secret);
  return BASE64.stringify(hash);
};

export const fixedEncodeUriComponent = (str: string): string => {
  return encodeURIComponent(str)
    .replace(/[!'()]/g, escape)
    .replace(/\*/g, '%2A');
};

export const normalizeForUrl = (name: string): string => {
  return name.replace(/ /g, '_').replace(URL_REGEX, '');
};

export const checkIfTrue = (value: string): boolean => {
  return ['true', '1', true, 1, 'yes'].indexOf(value) >= 0;
};

export const unslugify = (slug: string): string => {
  const result = slug.replace(/-/g, ' ');
  return result.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const getQueryParamByName = (name: string) => {
  var regexS = '[\\?&]' + name + '=([^&#]*)';
  var regex = new RegExp(regexS);
  var results = regex.exec(window.location.search);

  if (results === null) return '';
  else return decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const decodeObject = (obj: Record<string, string>) => {
  const decodedObj: Record<string, string> = {};
  Object.keys(obj).forEach((key) => {
    decodedObj[key] = decodeURIComponent(obj[key].replace(/\+/g, '%20'));
  });

  return decodedObj;
};
